/**
 * DealFieldUpdatedBanner — confirms a deal metadata update inline.
 *
 * Chat V1.2 (HANDOFF_CHAT_V1_2_GENERATIVE_TOOLS).
 */
import { Edit3 } from 'react-feather';

import type { ToolResultProps } from '../lib/component-registry';

interface UpdateDealFieldResult {
  deal_id?: number;
  deal_name?: string;
  updated_fields?: string[];
  is_error?: boolean;
  message?: string;
}

export function DealFieldUpdatedBanner({ result }: ToolResultProps) {
  const r = (result ?? {}) as UpdateDealFieldResult;

  if (r.is_error) {
    return (
      <div className="mt-2 border border-error/40 bg-error/5 px-3 py-2 text-body-sm text-txt-secondary">
        Could not update deal: {r.message ?? 'unknown error'}
      </div>
    );
  }

  const fields = r.updated_fields ?? [];
  const fieldList = fields.length > 0
    ? fields.map((f) => f.replace(/_/g, ' ')).join(', ')
    : 'fields';

  return (
    <div className="mt-2 flex items-center gap-2 border border-border bg-surface-card px-3 py-2 text-body-sm">
      <Edit3 size={14} className="shrink-0 text-txt-secondary" />
      <p className="text-txt-primary">
        <span className="font-semibold">{r.deal_name ?? `Deal #${r.deal_id}`}</span>
        {' '}updated: {fieldList}.
      </p>
    </div>
  );
}
